import { render, staticRenderFns } from "./PDFLoader534A.vue?vue&type=template&id=7a8769d8&scoped=true&"
import script from "./PDFLoader534A.vue?vue&type=script&lang=ts&"
export * from "./PDFLoader534A.vue?vue&type=script&lang=ts&"
import style0 from "./PDFLoader534A.vue?vue&type=style&index=0&id=7a8769d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8769d8",
  null
  
)

export default component.exports